module.exports = __webpack_public_path__ + "static/media/instagram.fbcd1a2e.svg";